import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from '../../design-system/settings/variables/Colors';
import { MEDIA_BREAKPOINTS } from '../../design-system/settings/variables/Breakpoints';

const StyledDiv = styled.div`
  display: flex;
  gap: ${SPACERS.medium};
  flex-direction: column;
  align-items: center;
  padding: ${SPACERS.extraLarge};
  background-color: ${COLORS.greyLightest};
  .heading-wrapper {
    display: flex;
    flex-direction: column;
  }
  .tasks-wrapper {
    display: flex;
    gap: ${SPACERS.large};
    ${MEDIA_BREAKPOINTS.smallerThanSmall} {
      flex-direction: column;
    }
  }
  .task {
    padding: ${SPACERS.large};
    display: flex;
    gap: ${SPACERS.small};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${COLORS.whiteBase};
    border-radius: 4px;
    border: 1px solid ${COLORS.greyLight};
    text-align: center;
  }
  .icon {
    font-size: 40px;
    color: ${COLORS.greyDark};
  }
`;

export function AngleDown() {
  return <FontAwesomeIcon icon={faAngleDown} />;
}

export interface FooterEventProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tasks: any;
  heading: string;
  intro: string;
}

const Footer: React.FC<FooterEventProps> = ({ tasks, heading, intro }) => {
  return (
    <StyledDiv>
      <div className="heading-wrapper">
        <TrueImpactText variant="heading-subheading" align="center">
          {heading}
        </TrueImpactText>
        <TrueImpactText variant="body" align="center">
          {intro}
        </TrueImpactText>
      </div>
      <div className="tasks-wrapper">
        {tasks.map(task => (
          <div className="task">
            <FontAwesomeIcon icon={task.icon} className="icon" />
            <div className="task-content">
              <TrueImpactText variant="heading-subheading" className="manager">
                {task.name}
              </TrueImpactText>
              <TrueImpactText variant="body">{task.text}</TrueImpactText>
            </div>
          </div>
        ))}
      </div>
    </StyledDiv>
  );
};

export default Footer;
